import React from 'react'
import { connect } from 'react-redux'

import { updatePurchaseOrderNumber } from './paymentMethodActionCreators'

import { Fade } from '../../componentAnimations'
import { translateResourceString } from '../../../util/translationUtility';

const PurchaseOrderComponent = ({
    poNumber,
    selected,
    onChange,
    placeholder = translateResourceString("/Checkout/PaymentInformation/Purchase/PONumberPlaceholder"),
    onPaymentIsValid
}) => (
    <Fade inProp={selected} >
        <div className=' form-group'>
            <input
                className="form-control col-6"
                name='ponumber'
                id='ponumber'
                type='text'
                placeholder={placeholder}
                onChange={e => (e.key === "Enter" && onPaymentIsValid(e)) || onChange(e)}
                value={poNumber}
            />
        </div>
    </Fade>
)

const mapStateToProps = (state, ownProps) => ({
    poNumber: state.entities.PaymentRecord.POValue || "",
    selected: state.entities.SelectedPaymentOptionId === state.constants.purchaseOrderPaymentId,
    ...ownProps
})

const mapDispatchToProps = dispatch => ({
    onChange: (e) => (e && e.target && dispatch(updatePurchaseOrderNumber(e.target.value)))
})

const PurchaseOrderComponentContainer = connect(mapStateToProps, mapDispatchToProps)(PurchaseOrderComponent)

export default PurchaseOrderComponentContainer
